import { isString } from 'lodash-es';
import { z } from 'zod';

export const UserProfileSchema = z.object({
  firstName: z.string().min(1, { message: '' }).max(50, 'Too long'),
  lastName: z.string().min(1, { message: '' }).max(50, 'Too long'),
  company: z.string().min(1, { message: '' }).max(100, 'Too long'),
  title: z.string().min(1, { message: '' }).max(100, 'Too long'),
  email: z.email('Invalid email').min(1),
});

export function isValidEmail(email: string): boolean {
  return z.email().safeParse(email).success;
}

export function isValidPassword(password: string): boolean {
  return z.string().min(8, 'Too short').max(128, 'Too long').safeParse(password)
    .success;
}

export function isValidHttpUrl(arg: string | undefined): boolean {
  if (!isString(arg)) return false;
  return arg.startsWith('http://') || arg.startsWith('https://');
}
